import request from '../utils/request';
const querystring = require('querystring')
//获取渠道下拉框数据
export const fetchSelect = query => {
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkGoods/getSelect.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//获取列表数据
export const fetchData = query => {
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};

export const fetchCopy = query => {
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/fetchCopy.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//保存新增
export const saveForm = query => {
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/insert.do',
        method: 'post',
        header:{"Content-Type":"multipart/form-data"},
        params: query
    }); 
    return list;
};
//主图上传服务器
export const uploadMainPlain = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/common/uploadMainPlain.do',
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};
export const uploadMasterPlain = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/common/uploadMasterPlain.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' }, 
        method: 'post',
        data:  query, 
    }); 
    return list;
};
//详情图上传服务器
export const uploadDetailPlain = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/common/uploadDetailPlain.do',
        headers: { 'Content-Type':  'multipart/form-data;charset=utf-8' }, 
        method: 'post',
        data:  query, 
    }); 
    return list;
};
//主图删除 
export const removeMasterPlain = query => {  
    var list = request({
        url: 'haoka/common/removeMasterPlain.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    });
    return list;
};

//详情图删除 
export const removeDetailPlain = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/common/removeDetailPlain.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    });
    return list;
};
//获取详情图
export const backDetailImg = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkFiles/backDetailImg.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
}; 
//复制商品信息
export const handleCopy = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/handleCopy.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list;
};
//删除
export const handDelete = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/handDelete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
//批量删除 
export const handDeleteBatch = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/handDeleteBatch.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//修改
export const changeForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/changeForm.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//查询选中渠道的商品id
export const getSkuCodes = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/getSkuCodes.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//上下架
export const downOrTopSave = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/downOrTopSave.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

//修改排序id 
export const updateAesId = query => { 
    query.secret = localStorage.getItem('ms_secret');
    var list = request({
        url: 'haoka/hkGoods/updateAesId.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};



